import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import * as API from '../../Endpoints/Endpoints';

const ViewChariot = () => {
  const { globalid, chariotid } = useParams();
  const [data, setData] = useState(null);
  const [type, setType] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;
        if (globalid) {
          setType('global');
          response = await axios.get(API.GET_GLOBAL_ETHICS_BYID(globalid));
        } else if (chariotid) {
          setType('chariot');
          response = await axios.get(API.GET_AI_CHARIOT_BYID(chariotid));
        }

        if (response) {
          const item = Array.isArray(response.data) ? response.data[0] : response.data;
          setData(item);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, [globalid, chariotid]);

  if (!data) return <div className="p-4">Loading...</div>;

  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow-md rounded-md">
      <h2 className="text-2xl font-bold mb-6 text-center">
        {type === 'global' ? 'Global Ethics Details' : 'AI Career Chariot Details'}
      </h2>

      <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700">Chariot Name</label>
          <input type="text" readOnly value={data.chariotname || ''} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block text-gray-700">Theme</label>
          <input type="text" readOnly value={data.theme || ''} className="w-full border px-3 py-2 rounded" />
        </div>

        {type === 'global' && (
          <>
            <div>
              <label className="block text-gray-700">Religion</label>
              <input type="text" readOnly value={data.religion || ''} className="w-full border px-3 py-2 rounded" />
            </div>

            <div className="md:col-span-2">
              <label className="block text-gray-700">Religious Quote</label>
              <textarea readOnly value={data.religiousquote || ''} className="w-full border px-3 py-2 rounded" rows={3} />
            </div>
          </>
        )}

        {type === 'chariot' && (
          <>
            <div>
              <label className="block text-gray-700">AI Career Role</label>
              <input type="text" readOnly value={data.aicareerrole || ''} className="w-full border px-3 py-2 rounded" />
            </div>

            <div className="md:col-span-2">
              <label className="block text-gray-700">AI Insight</label>
              <textarea readOnly value={data.aiinsight || ''} className="w-full border px-3 py-2 rounded" rows={3} />
            </div>
          </>
        )}

        <div>
          <label className="block text-gray-700">Wheel Number</label>
          <input type="text" readOnly value={data.wheelnumber || ''} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block text-gray-700">Wheel Name</label>
          <input type="text" readOnly value={data.wheelname || ''} className="w-full border px-3 py-2 rounded" />
        </div>

        <div className="md:col-span-2">
          <label className="block text-gray-700">Moral Science Question</label>
          <textarea readOnly value={data.moralsciencequestion || ''} className="w-full border px-3 py-2 rounded" rows={2} />
        </div>

        <div>
          <label className="block text-gray-700">Age Group</label>
          <input type="text" readOnly value={data.agegroup || ''} className="w-full border px-3 py-2 rounded" />
        </div>

        <div>
          <label className="block text-gray-700">Standard</label>
          <input type="text" readOnly value={data.standard || ''} className="w-full border px-3 py-2 rounded" />
        </div>
      </form>
    </div>
  );
};

export default ViewChariot;
